import { APP } from 'src/Configs/App'

import { api } from './api'

const UPLOAD_REQUEST_TIMEOUT = 300000
const MAX_PERCENTAGE = 100

export interface PreReleaseTrackFileResponse {
  audioUrl: string
}

export interface UploadPreReleaseTrackFileParams {
  campaignId: string
  file: File
  onProgress?: (percentage: number) => void
}

const getTrackFileUrl = (campaignId: string): string =>
  `${APP.TIKTOK_SERVER}/artist/spotify-campaigns/${campaignId}/pre-release-track-file`

export const uploadPreReleaseTrackFile = async ({
  campaignId,
  file,
  onProgress,
}: UploadPreReleaseTrackFileParams): Promise<PreReleaseTrackFileResponse> => {
  const formData = new FormData()
  formData.append('file', file)

  const { data } = await api.post<PreReleaseTrackFileResponse>(
    getTrackFileUrl(campaignId),
    formData,
    {
      timeout: UPLOAD_REQUEST_TIMEOUT,
      onUploadProgress: ({ loaded, total }) => {
        if (!total) {
          return
        }
        onProgress?.(
          Math.min(
            MAX_PERCENTAGE,
            Math.round((loaded / total) * MAX_PERCENTAGE),
          ),
        )
      },
    },
  )

  return data
}

export const deletePreReleaseTrackFile = async (
  campaignId: string,
): Promise<void> => {
  await api.delete(getTrackFileUrl(campaignId))
}
